import * as openpgp from "openpgp";

export type ArmoredKeyPair = { privateKey: string, publicKey: string }

const loadOrGenerateKeys = async (uuid: string): Promise<ArmoredKeyPair> => {
  const keysStorageKey = `keys_${uuid}`
  const storedKeys = localStorage.getItem(keysStorageKey)

  let keys: ArmoredKeyPair
  if (!storedKeys) {
    keys = await openpgp.generateKey({ curve: 'brainpoolP512r1',  userIDs: [{ name: 'Test', email: 'test@test.com' }] });
    localStorage.setItem(keysStorageKey, JSON.stringify(keys))
  } else {
    keys = JSON.parse(storedKeys)
  }

  return keys
}

export {
  loadOrGenerateKeys,
}
